import CodeBlockIcon from '@carbon/icons/es/code/16';
import CodeBlockEditing from '@ckeditor/ckeditor5-code-block/src/codeblockediting';
import { createCarbonIconPlugin } from './carbon-icon';

export const CODE_BLOCK = 'codeBlock';
export const CodeBlock = createCarbonIconPlugin({
  name: 'CodeBlock',
  editing: CodeBlockEditing,
  uis: [
    {
      command: CODE_BLOCK,
      params: { language: 'plaintext' },
      icon: CodeBlockIcon,
      label: 'Insert code block',
    },
  ],
});
